import { Table } from '@ih/app/shared/apis/interfaces';

export class SetTables {
  public static readonly type = '[Project/Tables/List] SetTables';
  constructor(public readonly tables: Table[]) {}
}
